// extracted by mini-css-extract-plugin
export default {"Switch":"CustomSwitch_Switch__lsW-j","Slider":"CustomSwitch_Slider__uclaL","Round":"CustomSwitch_Round__ge2L2"};